import NavSideBar from "../component/NavSideBar";

export default function Charts() {
  return (
    <NavSideBar>
        <div className="p-10 text-3xl font-bold">Charts</div>
    </NavSideBar>
  )
}
